import { render } from "./Thanks.vue?vue&type=template&id=77882448&scoped=true"
const script = {}

import "./Thanks.vue?vue&type=style&index=0&id=77882448&scoped=true&lang=scss"

import exportComponent from "X:\\Git\\Patreon-Linker\\patreon-linker\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77882448"]])

export default __exports__